// ** Redux Imports
import React from 'react'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import urls from  '@src/@core/auth/jwt/urls'
import { toast } from 'react-toastify'
// ** Axios Imports
import axios from 'axios'

export const getAllData = createAsyncThunk('appDocuments/getAllData', async (params) => {
  const instanceGet = axios.create({
    baseURL: urls.url,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })
  const response = await instanceGet.get(`/customers/documents/`, {params: {page_size: params.page_size, p:params.page, idCustomer:params.idCustomer, id:params.document, status:params.status, start:params.start, end:params.end, doc_type:params.doc_type, cost_center:params.cost_center, seller:params.seller}})
  return response
})

export const getDocument = createAsyncThunk('appDocuments/getDocument', async id => {
  const instance = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })
  const response = await instance.get(`/customers/documents/${id}/document/`)
  // console.log(response.data)
  return response.data
})

export const getAllDataConciliation = createAsyncThunk('appDocuments/getAllDataConciliation', async (params) => {
  const instanceGet = axios.create({
    baseURL: urls.url,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })
  const response = await instanceGet.get(`/customers/documents/list_for_conciliation/`, {params: {idCustomer:params.idCustomer, status:params.status, local_collection:params.local_collection}})
  return response
})

export const getDocumentsContifico = createAsyncThunk('appDocuments/getDocumentsContifico', async(props, {dispatch, getState}) => {
  const state = getState()
  const instancePost = axios.create({
    baseURL: urls.url,
    timeout: -1,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })

  const promise = async () => {
    try {
      await instancePost.post("/customers/documents/sync_documents_with_contifico/", {})
      dispatch(getAllData({ page: 1, idCustomer: "", document: "", status: "", start: "", end: "" }))
    } catch (err) {
      console.error(err)
    }
  }

  if (!state.loading) {
    await toast.promise(promise, {
      pending: 'Sincronizando documentos',
      loading: 'Sincronizando documentos',
      success: 'Documentos sincronizados',
      error: 'Ha ocurrido un error'
    })
  }
  
})

export const setIsFetchingResults = createAsyncThunk('appDocuments/setIsFetchingResults', () => {
  return "fetching"
})

export const cleanDocuments = createAsyncThunk('appDocuments/cleanContacts', () => {
  return "clean"
})

export const appDocumentsSlice = createSlice({
  name: 'appDocuments',
  initialState: {
    allData: [],
    total: 1,
    loading: false,
    isFetching: false,
    document : null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload.data.results
        state.total = action.payload.data.count
        state.isFetching = false
      })
      .addCase(getDocument.fulfilled, (state, action) => {
        state.document = action.payload
        state.isFetching = false
      })
      .addCase(getAllDataConciliation.fulfilled, (state, action) => {
        if (Array.isArray(action.payload.data)) {
          state.allData = action.payload.data
          state.total = action.payload.data.length
        } else {
          //en caso de agregar paginación
          state.allData = action.payload.data.results || []
          state.total = action.payload.data.count || 0
        }
        state.isFetching = false
      })
      .addCase(getDocumentsContifico.pending, (state) => {
        state.loading = true
      })
      .addCase(setIsFetchingResults.fulfilled, (state) => {
        state.isFetching = true
      })
      .addCase(getDocumentsContifico.fulfilled, (state) => {
        state.loading = false
      })
  
      .addCase(cleanDocuments.fulfilled, (state) => {
        state.allData = []
        state.total = 1
      })

  }
})

export default appDocumentsSlice.reducer
